<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3 v-if="tur == 'Stok'">Stok İşlemleri</h3>
        <h3 v-if="tur == 'Fatura'">Fatura İşlemleri</h3>
        <h3 v-if="tur == 'Sarf'">Sarf İşlemleri</h3>
        <h3 v-if="tur == 'ACT'">Cari İşlemleri</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="3" sm="6">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="listeleTop"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="3" sm="6">
            <v-select
              v-model="secilenDurum"
              :options="durumList"
              label="name"
              placeholder="Aktif"
              style=""
              @input="listeleTop()"
            >
            </v-select>
          </b-col>

          <b-col lg="3" sm="6">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              color="danger"
              @click="listeleTop()"
              >Listele</vs-button
            >
          </b-col>
          <b-col lg="3" sm="6">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="yeniEkle()"
              >Yeni</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <CariDetayComponent ref="cariDetay" />
    <StokDetayComponent ref="stokDetay" />
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import CariDetayComponent from "./CariDetayComponent.vue";
import StokDetayComponent from "./StokDetayComponent.vue";
import router from "../../../../router";

export default {
  props: ["gelentur"],
  created() {
    this.turAl = this.gelentur;

    this.tur = this.gelentur;
  },
  components: {
    CariDetayComponent,
    "v-select": vSelect,
    StokDetayComponent,
  },
  data() {
    return {
      secilenDurum: "",

      arananDeger: "",
      tur: "",
      turAl: "",
      durumList: [
        { name: "Aktif", val: 2 },
        { name: "Pasif", val: 3 },
      ],
    };
  },

  methods: {
    yeniEkle() {
      if (this.tur == "Stok") this.$refs.stokDetay.stokDetayComponent();
      else if (this.tur == "Fatura") router.push("/finans/fatura_detay");
      else if (this.tur == "Sarf") router.push("/islemler/sarf-page");
      else if (this.tur == "ACT") this.$refs.cariDetay.stokDetayComponent();
    },
    getTahsilatRaporList() {},
    listeleTop() {
      if (typeof this.secilenDurum.val == "undefined") {
        this.$emit("secilenDurum", "2");
      } else {
        this.$emit("secilenDurum", this.secilenDurum.val);
      }
      this.$emit("aranan", this.arananDeger);

      this.$parent.listeleme();
    },
  },
};
</script>